<template>
  <div class="box1">
    
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;

  width: 100%;
  height: 600px;
  background: url("../../../assets/coursePage/nau/box1/banner.png") no-repeat;
  background-size: cover;
  background-position: center;

  box-sizing: border-box;
  
}
</style>
